import { getContext } from '../helpers/getContext'
import { SegmentMethod } from '../interfaces'

export const track: SegmentMethod = (
  { type, payload },
  trackId,
  userId,
  anonymousId,
  locale = null
) =>
  globalThis.analytics?.track({
    userId,
    event: type,
    anonymousId,
    properties: { ...payload, trackId },
    context: getContext(locale),
  })
